import React from 'react';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../../commons/BurgerMenu';
import Header from '../../../commons/Header';
import { ReactComponent as IconBuilding } from '../../../images/icn_buildings.svg';
import { Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import { ContFilterYear } from '../../../styled-components';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import { formatDateTime } from '../../../lib/helpers/date';
import GeneralTable from './GeneralTable';
import InvoiceTable from './InvoiceTable';
import PartnerEonTable from './PartnerEonTable';
import RecurringFeeTable from './RecurringFeeTable';
import InsuranceTable from './InsuranceTable';
import SignalTable from './SignalTable';

const MyGiveAndTakeAdminPresentational = ({
  data,
  onFilter,
  profile,
  query,
  total,
  onShowInfo,
  onShowIafs,
}) => {
  const [t] = useTranslation('GIVE_AND_TAKE');

  const tableProps = {
    data: data && data[0],
    total,
    onFilter,
    onShowInfo,
    onShowIafs,
    year: query && query.year,
  };

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section style={{ marginBottom: '20px' }}>
          <Header
            title={t('PAGES:GIVE_AND_TAKE')}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />
          <Row
            className="search-add-cont m-t-20"
            style={{ rowGap: '1rem', marginBottom: '1rem' }}
          >
            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('SEARCH_BY_YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectYear"
                        name="year"
                        value={query && query.year}
                        onChange={({ target: { value: year } }) => {
                          onFilter({ year });
                        }}
                      >
                        {generateYearOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            {data?.[0]?.updatedAt && (
              <Col
                sm="12"
                md="6"
                lg="9"
                className="text-right"
                style={{ alignSelf: 'center', fontWeight: 'bold' }}
              >
                {t('LAST_UPDATED')}: {formatDateTime(data[0].updatedAt)}
              </Col>
            )}
          </Row>

          <div
            style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}
          >
            <GeneralTable {...tableProps} />
            <InvoiceTable {...tableProps} />
            <PartnerEonTable {...tableProps} />
            <RecurringFeeTable {...tableProps} />
            {/* <InsuranceTable {...tableProps} /> */}
            <SignalTable {...tableProps} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default MyGiveAndTakeAdminPresentational;
